<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">{{ $route.meta.title }}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="filter" :model="filter" :label-width="100" label-position="right" @submit.native.prevent>
        <Row type="flex">
          <Col v-bind="grid">
            <FormItem label="筛选基地：" label-for="key">
              <Select v-model="filter.land_base_id" class="perW100" @on-change="selectLandBase">
                <Option :value="0">全部</Option>
                <Option v-for="(item, key) in landBaseList" :value="key" :key="key">{{ item }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="筛选地块：" label-for="key">
              <Select v-model="filter.land_id" class="perW100" @on-change="selectLandInfo">
                <Option :value="0">全部</Option>
                <Option v-for="(item, key) in landInfoList" :value="key" :key="key">{{ item }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="创建时间：" prop="key" label-for="key">
              <DatePicker type="daterange" :value="filter.ctime" confirm placeholder="请选择查询时间段"
                          style="width: 100%" @on-ok="dateOk" @on-change="dateChange"
                          @on-clear="dateClear"></DatePicker>
            </FormItem>
          </Col>
        </Row>
        <Row type="flex" style="flex-wrap: nowrap;justify-content: space-between;margin: 20px 20px 0 20px">
          <Col style="margin: 0 10px">
            <Button type="primary" icon="md-add" @click="add">添加</Button>
          </Col>
        </Row>
      </Form>

      <Table :columns="columns" stripe :data="tableData" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >

        <template slot-scope="{ row, index }" slot="action">
          <a @click="edit(row.id)">编辑</a>
          <Divider type="vertical"/>
          <a @click="info(row.id)">查看</a>
          <Divider type="vertical"/>
          <a @click="del(row.id)">删除</a>
        </template>

      </Table>
      <Page :total="tableCount" :current="filter.page" :page-size="filter.limit" class="acea-row row-right page"
            show-total @on-change="changePage"></Page>
    </Card>
  </div>
</template>

<script>
import {plantSaleListApi, plantSaleDelApi} from '@/api/plant/plantSale'
import {landBaseAllApi} from "@/api/landBase/landBase";
import {landInfoAllApi} from "@/api/landBase/landInfo";

export default {
  name: 'plantSaleList',
  inject: ['reload'],
  data() {
    return {
      grid: {
        xs: 24,
        sm: 24,
        md: 12,
        lg: 7,
        xl: 7
      },
      filter: {
        page: 1,
        limit: 10,
        ctime: [],
        land_base_id: 0,
        land_id: 0,
      },
      tableData: [],
      tableCount: 0,
      loading: false,
      landBaseList: [],
      landInfoList: [],
      columns: [
        {
          title: '所属基地',
          key: 'land_base_name',
          minWidth: 120
        },
        {
          title: '基地企业',
          key: 'land_base_company_name',
          minWidth: 150
        },
        {
          title: '所属地块',
          key: 'land_sn',
          minWidth: 120
        },
        {
          title: '作物名称',
          key: 'plant',
          minWidth: 100
        },
        {
          title: '订单号',
          key: 'sn',
          minWidth: 200
        },
        {
          title: '销售总量(kg)',
          key: 'total_num',
          minWidth: 120
        },
        {
          title: '销售单价',
          key: 'sale_price',
          minWidth: 100
        },
        {
          title: '销售总价',
          key: 'total_price',
          minWidth: 100
        },
        {
          title: '销售类型',
          key: 'type_msg',
          minWidth: 120
        },
        {
          title: '销售公司',
          key: 'sale_company',
          minWidth: 150
        },
        {
          title: '销售公司联系电话',
          key: 'sale_company_phone',
          minWidth: 150
        },
        {
          title: '销售日期',
          key: 'sale_date',
          minWidth: 100
        },
        {
          title: '创建时间',
          key: 'ctime',
          minWidth: 150
        },
        {
          title: '操作',
          slot: 'action',
          fixed: 'right',
          minWidth: 150
        }
      ]
    }
  },
  created() {
    this.loadLandBaseData()
    this.loadLandInfoData()
    this.loadTableData()
  },
  methods: {
    loadTableData() {
      this.loading = true
      plantSaleListApi(this.filter).then(res => {
        this.tableData = res.data.list
        this.tableCount = res.data.count
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    // 分页
    changePage(status) {
      this.filter.page = status
      this.loadTableData()
    },
    // 搜索
    search() {
      this.filter.page = 1
      this.loadTableData()
    },
    // 搜索清空
    searchClear() {
      this.filter.page = 1
      this.filter.search = ''
      this.loadTableData()
    },
    // 选择时间
    dateOk() {
      this.filter.page = 1
      this.loadTableData()
    },
    // 时间切换
    dateChange(dateArr) {
      this.filter.ctime = dateArr
    },
    // 时间清空
    dateClear() {
      this.filter.ctime = []
      this.loadTableData()
    },

    // 添加
    add() {
      this.$router.push({path: this.pathFormat(this.$route.path)})
    },
    // 编辑
    edit(id) {
      this.$router.push({path: this.pathFormat(this.$route.path, 'edit', id)})
    },
    info(id) {
      this.$router.push({path: this.pathFormat(this.$route.path, 'info', id)})
    },
    // 删除
    del(id) {
      this.$Modal.confirm({
        title: '提示',
        content: '是否确认删除？',
        onOk: () => {
          plantSaleDelApi(id).then(res => {
            if (res.code === 200) {
              this.$Message.success('删除成功')
              this.reload()
            } else {
              this.$Message.error(res.msg)
            }
          }).catch(res => {
            this.$Message.error(res.msg)
          })
        }
      })
    },

    // 所有基地
    loadLandBaseData() {
      landBaseAllApi({type: 1}).then(res => {
        if (res.code === 200) {
          this.landBaseList = res.data
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    // 选择基地
    selectLandBase() {
      this.filter.page = 1
      this.loadLandInfoData()
      this.loadTableData()
    },

    // 所有地块
    loadLandInfoData() {
      landInfoAllApi({land_base_id: this.filter.land_base_id}).then(res => {
        if (res.code === 200) {
          this.landInfoList = res.data
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    // 选择地块
    selectLandInfo(){
      this.filter.page = 1
      this.loadTableData()
    },

  }
}
</script>
